(() => {
  const title = document.querySelector('.hero__title');
  const canvas = title?.querySelector('.hero__matrix');
  if (!canvas || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // A small bitmap alphabet keeps the headline made of the same square cells
  // throughout the change, rather than crossfading two blocks of text.
  const glyphs = {
    A: ['01110','10001','10001','11111','10001','10001','10001'],
    B: ['11110','10001','10001','11110','10001','10001','11110'],
    C: ['01111','10000','10000','10000','10000','10000','01111'],
    D: ['11110','10001','10001','10001','10001','10001','11110'],
    F: ['11111','10000','10000','11110','10000','10000','10000'],
    I: ['11111','00100','00100','00100','00100','00100','11111'],
    K: ['10001','10010','10100','11000','10100','10010','10001'],
    L: ['10000','10000','10000','10000','10000','10000','11111'],
    O: ['01110','10001','10001','10001','10001','10001','01110'],
    P: ['11110','10001','10001','11110','10000','10000','10000'],
    R: ['11110','10001','10001','11110','10100','10010','10001'],
    T: ['11111','00100','00100','00100','00100','00100','00100'],
    U: ['10001','10001','10001','10001','10001','10001','01110'],
    Y: ['10001','10001','01010','00100','00100','00100','00100'],
    0: ['01110','10011','10101','10101','11001','10001','01110'],
    6: ['01110','10000','10000','11110','10001','10001','01110'],
    '%': ['11001','11010','00100','00100','01011','10011','00000']
  };
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  let from = new Set();
  let to = new Set();
  let cells = [];
  let pitch = 10;
  let width = 0;
  let height = 0;
  let start = performance.now();

  function matrix(lines) {
    const dots = new Set();
    let widest = 0;
    lines.forEach((line, lineIndex) => {
      let x = 0;
      for (const letter of line) {
        if (letter === ' ') { x += 3; continue; }
        glyphs[letter]?.forEach((row, y) => {
          [...row].forEach((bit, dx) => {
            if (bit === '1') dots.add(`${x + dx},${lineIndex * 9 + y}`);
          });
        });
        x += 6;
      }
      widest = Math.max(widest, x - 1);
    });
    return { dots, columns: widest, rows: (lines.length - 1) * 9 + 7 };
  }

  function size() {
    const mobile = matchMedia('(max-width: 860px)').matches;
    const first = matrix(mobile ? ['BLACK', 'FRIDAY'] : ['BLACK FRIDAY']);
    const second = matrix(mobile ? ['UP TO', '60% OFF'] : ['UP TO 60% OFF']);
    const available = innerWidth - (mobile ? 36 : innerWidth / 12 + 24);
    const widest = Math.max(first.columns, second.columns);
    pitch = mobile
      ? Math.min(10.3, available / widest)
      : Math.min(10.3, Math.max(5.5, innerWidth * .0072), available / widest);
    width = Math.ceil(widest * pitch);
    height = Math.ceil(Math.max(first.rows, second.rows) * pitch);
    const dpr = Math.min(devicePixelRatio || 1, 2);
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    canvas.width = Math.ceil(width * dpr);
    canvas.height = Math.ceil(height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    from = first.dots;
    to = second.dots;
    cells = [...new Set([...from, ...to])].map(key => {
      const [x, y] = key.split(',').map(Number);
      return { key, x, y, delay: ((x * 19 + y * 37) % 41) / 100 + x / 200 };
    });
  }

  function draw(now) {
    const time = (now - start) % 6500;
    const switching = (time >= 2300 && time < 3150) || (time >= 5650);
    const reverse = time >= 3150;
    const progress = time < 3150 ? (time - 2300) / 850 : (time - 5650) / 850;
    const before = reverse ? to : from;
    const after = reverse ? from : to;
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = '#fff';
    for (const cell of cells) {
      const wasOn = before.has(cell.key);
      const willBeOn = after.has(cell.key);
      let opacity = wasOn ? 1 : 0;
      if (switching) {
        const local = Math.max(0, Math.min(1, (progress - cell.delay) / .34));
        opacity = wasOn === willBeOn ? (wasOn ? 1 - .3 * Math.sin(local * Math.PI) : 0)
          : wasOn ? 1 - local : local;
      }
      if (opacity < .02) continue;
      ctx.globalAlpha = opacity;
      const inset = Math.max(1, pitch * .09);
      ctx.fillRect(cell.x * pitch + inset, cell.y * pitch + inset,
        pitch - inset * 1.6, pitch - inset * 1.6);
    }
    ctx.globalAlpha = 1;
    requestAnimationFrame(draw);
  }

  size();
  title.classList.add('is-matrix-ready');
  addEventListener('resize', size, { passive: true });
  requestAnimationFrame(draw);
})();
